// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:720px){.doublePicture img:not(.translated).noTranslate[data-v-3a7dbb94],.notifPicture[data-v-3a7dbb94]{min-width:40px;width:40px;height:40px;border-radius:40px;margin-right:32px}}", ""]);
// Exports
module.exports = exports;
